import {
  ComponentsOverrides,
  ComponentsProps,
  ComponentsVariants,
  Theme,
} from '@mui/material';
import { tannerGray } from '../colors';

type MuiPaginationItem = {
  styleOverrides?: ComponentsOverrides<Theme>['MuiPaginationItem'];
  defaultProps?: ComponentsProps['MuiPaginationItem'];
  variants?: ComponentsVariants['MuiPaginationItem'];
};

export const MuiPaginationItem: MuiPaginationItem = {
  styleOverrides: {
    root: {
      '&:hover': {
        backgroundColor: tannerGray['100'],
        color: tannerGray['700'],
      },
    },
  },
};
